export default __webpack_public_path__ + "static/media/arrowDownCircleFill.651f6a65.svg";